import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { HOC } from 'formsy-react';
import Checkbox from 'material-ui/Checkbox';
import MatrixButton from '../shared/MatrixButton';
import recurrenceTypes from '../../../../settings/constants/recurrenceTypes';
import globals from '../../../../globals/communityGlobals';
import timeSlotPropType from '../../../../propTypes/entities/timeSlot';
import { handleButtonClicks } from '../shared/functions';

const locale = globals.getArea('treatments');

class TimeSlotsMatrix extends Component {
  constructor(props) {
    super(props);
    this.handleButtonClicks = handleButtonClicks.bind(this);
  }
  componentWillReceiveProps = newProps => {
    // Limit the value to a single row if the pattern changes and recurrenceType == daily
    // Prevents some 'hidden' leftover values being submitted when switching between
    // patterns or resetting the form
    const { recurrenceType, getValue, setValue } = this.props;
    if (recurrenceType !== newProps.recurrenceType && recurrenceType !== recurrenceTypes.DISABLED) {
      if (newProps.recurrenceType === recurrenceTypes.DAILY || newProps.recurrenceType === recurrenceTypes.DISABLED) {
        const currentValue = getValue() || {};
        setValue({ 0: currentValue[0] || undefined });
      }
    }
  };

  selectAllTimeslots = row => {
    const { getValue, setValue, timeSlots } = this.props;
    const stateOfButtons = getValue();
    const newRow = {};

    Object.values(timeSlots).forEach(timeSlot => {
      newRow[timeSlot.id] = true;
    });

    const newStateOfButtons = Object.assign({}, stateOfButtons);
    newStateOfButtons[row] = newRow;
    setValue(newStateOfButtons);
  };

  deselectAllTimeslots = row => {
    const { getValue, setValue } = this.props;
    const stateOfButtons = getValue();

    const newStateOfButtons = Object.assign({}, stateOfButtons);
    delete newStateOfButtons[row];
    setValue(newStateOfButtons);
  };

  generateButtonRows = () => {
    const { recurrenceType, timeSlots, disabled } = this.props;
    const buttons = [];
    const isDailyOrDisabled = recurrenceType === recurrenceTypes.DISABLED || recurrenceType === recurrenceTypes.DAILY;
    const columnLength = isDailyOrDisabled ? 1 : 7;
    for (let row = 0; row < columnLength; row += 1) {
      let rowSelected = true;
      const buttonsRow = timeSlots.map(timeSlot => {
        const stateOfButtons = this.props.getValue() || {};
        let rowIndex = row;
        if (columnLength === 1) {
          rowIndex = Object.keys(stateOfButtons)[0] || 0;
        }
        const buttonState =
          stateOfButtons[rowIndex] && stateOfButtons[rowIndex][timeSlot.id]
            ? stateOfButtons[rowIndex][timeSlot.id]
            : false;
        rowSelected = rowSelected && buttonState;
        return (
          <MatrixButton
            key={`matrixButton${`${rowIndex}x${timeSlot.id}`}`}
            label={timeSlot.name}
            row={rowIndex}
            position={timeSlot.id}
            clickUpdate={!disabled ? this.handleButtonClicks : () => {}}
            checked={buttonState}
          />
        );
      });

      buttonsRow.unshift(
        <td key={`matrixButton${`${row}`}`}>
          <Checkbox
            disabled={disabled}
            checked={rowSelected}
            onCheck={() => (rowSelected ? this.deselectAllTimeslots(row) : this.selectAllTimeslots(row))}
          />
        </td>,
      );
      const rowHeader = isDailyOrDisabled
        ? locale.getMsg('daily')
        : globals.now
            .utcOffset(0, true)
            .isoWeekday(row + 1)
            .format(globals.dateFormats.dayFull);
      buttons.push(
        <tr className="treat-sched-data-row" key={`timeSlotsMatrixRow${row}`}>
          {[<th key={`rowHeader${row}`}>{rowHeader}</th>, ...buttonsRow]}
        </tr>,
      );
    }
    return buttons;
  };

  render() {
    return this.props.timeSlots.length ? (
      <table className="treat-sched">
        <thead>
          <tr>
            {[
              <th className="treat-sched-header-start" key="timeSlotsMatrixTableEmptyHeader">
                {locale.getMsg('type')}
              </th>,
              <th key="timeSlotsMatrixTableSelectAllHeader">{locale.getMsg('selectAll')}</th>,
              ...this.props.timeSlots.map(({ from, to, id }) => (
                <th className="treat-sched-header" key={`timeSlotsMatrixTableHeader${id}`}>
                  {`${moment(from).format(globals.timeFormats.hours24)}`} <div> - </div>{' '}
                  {`${moment(to).format(globals.timeFormats.hours24)}`}
                </th>
              )),
            ]}
          </tr>
        </thead>
        <tbody>{this.generateButtonRows()}</tbody>
      </table>
    ) : (
      <div>{locale.getMsg('noTimeSlots')}</div>
    );
  }
}

TimeSlotsMatrix.defaultProps = {
  value: undefined,
  disabled: false,
};

TimeSlotsMatrix.propTypes = {
  recurrenceType: PropTypes.string.isRequired,
  timeSlots: PropTypes.arrayOf(timeSlotPropType).isRequired,
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default HOC(TimeSlotsMatrix);
